import { render } from "./manualBook.vue?vue&type=template&id=d419ca86&scoped=true"
import script from "./manualBook.vue?vue&type=script&lang=js"
export * from "./manualBook.vue?vue&type=script&lang=js"

import "./manualBook.vue?vue&type=style&index=0&id=d419ca86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d419ca86"]])

export default __exports__